interface SortOption {
  value: string;
  label: string;
}

interface SortSelectProps {
  value: string;
  options: SortOption[];
  onChange: (value: string) => void;
  label?: string;
}

export default function SortSelect({ value, options, onChange, label = "排序" }: SortSelectProps) {
  return (
    <label className="inline-flex items-center gap-2 font-label text-xs text-foreground-500">
      <span className="flex items-center gap-1">
        <i className="ri-sort-desc" aria-hidden="true"></i>
        {label}
      </span>
      <select
        value={value}
        onChange={(event) => onChange(event.target.value)}
        className="cursor-pointer rounded-md border border-background-300 bg-background-50 py-1.5 pl-2.5 pr-7 font-label text-xs text-foreground-800 outline-none transition-colors hover:border-primary-300 focus:border-primary-400"
      >
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </label>
  );
}